<app-header [navItems]="navItems" [enableBack]="false">
  <div title>{{ 'dashboard.title' | translate }}</div>
</app-header>

<div class="p-6 flex flex-col gap-4">
  <router-outlet></router-outlet>
</div>
